import { formatDistanceToNow } from "date-fns";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import ImageOutlinedIcon from "@mui/icons-material/ImageOutlined";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import LinkIcon from "@mui/icons-material/Link";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import { Box, CardContent } from "@mui/material";
import { Image } from "@avenue-8/sidekick-ui";
import {
  ActionSheetMenu,
  ActionSheetMenuItem,
  ResponsiveActionSheetMenu,
} from "@shared/components/ActionSheetMenu";
import {
  PresentationCardRoot,
  CoverImagePlaceholder,
  CoverImageWrapper,
  CardMenuButton,
  MenuIconButton,
  CardTitle,
  CardSubtitle,
} from "./PresentationCard.styles";

type PresentationCardProps = {
  id: string;
  title: string;
  clientDisplayName?: string;
  coverImage?: string;
  updatedDate: Date;
  onView: (id: string) => void;
  onEdit: (id: string) => void;
  onCopyLink: (id: string) => void;
  onDelete: (id: string) => void;
};

export function PresentationCard(props: PresentationCardProps) {
  const {
    id,
    title,
    clientDisplayName,
    coverImage,
    updatedDate,
    onView,
    onEdit,
    onCopyLink,
    onDelete,
  } = props;

  const relativeDate = formatDistanceToNow(updatedDate, { addSuffix: true });

  return (
    <PresentationCardRoot onClick={() => onEdit(id)}>
      <Box sx={{ flexGrow: 1, display: "flex", flexDirection: "column" }}>
        <CoverImageWrapper>
          {coverImage ? (
            <Image src={coverImage} alt={title} />
          ) : (
            <CoverImagePlaceholder>
              <ImageOutlinedIcon sx={{ fontSize: 40, opacity: 0.3 }} />
            </CoverImagePlaceholder>
          )}
        </CoverImageWrapper>
        <CardContent sx={{ flexGrow: 1 }}>
          <CardTitle variant="subtitle2">{title}</CardTitle>
          {clientDisplayName && (
            <CardSubtitle variant="body2">{clientDisplayName}</CardSubtitle>
          )}
          <CardSubtitle variant="body2">Updated {relativeDate}</CardSubtitle>
        </CardContent>
      </Box>
      <CardMenuButton onClick={(e) => e.stopPropagation()}>
        <ResponsiveActionSheetMenu
          renderTrigger={({ triggerRef, onClick }) => (
            <MenuIconButton
              ref={triggerRef}
              onClick={onClick}
              size="small"
              aria-label="Presentation options"
            >
              <MoreVertIcon fontSize="small" />
            </MenuIconButton>
          )}
        >
          {(closeMenu) => (
            <ActionSheetMenu>
              <ActionSheetMenuItem
                icon={<EditOutlinedIcon />}
                label="Edit Presentation"
                onClick={() => {
                  closeMenu();
                  onEdit(id);
                }}
              />
              <ActionSheetMenuItem
                icon={<VisibilityOutlinedIcon />}
                label="View Presentation"
                onClick={() => {
                  closeMenu();
                  onView(id);
                }}
              />
              <ActionSheetMenuItem
                icon={<LinkIcon />}
                label="Copy presentation link"
                onClick={() => {
                  closeMenu();
                  onCopyLink(id);
                }}
              />
              <ActionSheetMenuItem
                icon={<DeleteOutlineIcon />}
                label="Delete"
                onClick={() => {
                  closeMenu();
                  onDelete(id);
                }}
              />
            </ActionSheetMenu>
          )}
        </ResponsiveActionSheetMenu>
      </CardMenuButton>
    </PresentationCardRoot>
  );
}
